module.exports = __webpack_public_path__ + "static/hifi2-021722bfdbd4ec2765963ec6cde12491.jpg";